import React, { useEffect, useState } from 'react'
import {
  Button, Card, CardActions, CardContent, CardHeader, Container, CircularProgress,
  Grid, ImageList, ImageListItem, Link, Snackbar, Typography
} from '@material-ui/core'
import {
  AccountCircle, FlagRounded, OutlinedFlagRounded, Share, ShareOutlined, NavigateNext
} from '@material-ui/icons'
import { blue, grey } from '@material-ui/core/colors'
// import Identicon from 'identicon.js'
import { useStyles } from '../styles'
import { getLocalDateTime } from '../utils'
import { useDatabase } from '../DatabaseContext'
import UserProfileCard from './UserProfileCard'
import SharersList from './SharersList'
import FlaggersList from './FlaggersList'
import ErrorCard from './ErrorCard'

function PostCard({ id }) {

  const classes = useStyles()
  const {
    curUser, posts, loadPost, viewPost, flagPost, unFlagPost, sharePost, endPostTime,
    clickOnAuthorProfile, clickOnFriendProfile, clickOnSharersList, clickOnFlaggersList,
  } = useDatabase()

  const thisPost = posts[id]

  const [loading, setLoading] = useState(true)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const [expanded, setExpanded] = useState(false)
  const [hasRead, setHasRead] = useState(false)
  const [reading, setReading] = useState(false)
  const [flagging, setFlagging] = useState(false)
  const [sharing, setSharing] = useState(false)
  const [popupOpen, setPopupOpen] = useState(false)
  // const [sharePopupOpen, setSharePopupOpen] = useState(false)
  const [popupMessage, setPopupMessage] = useState('')
  // const [flaggedMessage, setFlaggedMessage] = useState('')
  // const [sharedMessage, setSharedMessage] = useState('')
  // const [anchorEl, setAnchorEl] = useState(null)
  const [userProfile, setUserProfile] = useState({})
  const [flaggersList, setFlaggersList] = useState([])
  const [sharersList, setSharersList] = useState([])
  const [sharersListOpen, setSharersListOpen] = useState(false)
  const [flaggersListOpen, setFlaggersListOpen] = useState(false)
  const [hasClickedOnAuthor, setHasClickedOnAuthor] = useState(false)
  const [hasClickedOnFriend, setHasClickedOnFriend] = useState(false)
  const [hasClickedOnSharers, setHasClickedOnSharers] = useState(false)
  const [hasClickedOnFlaggers, setHasClickedOnFlaggers] = useState(false)

  const handleRefresh = async () => {
    setLoading(true)
    setSubmitting(false)
    setError('')
    setExpanded(false)
    setHasRead(false)
    setReading(false)
    setFlagging(false)
    setSharing(false)
    setPopupOpen(false)
    setPopupMessage('')
    setUserProfile({})
    setSharersList([])
    setFlaggersList([])
    setSharersListOpen(false)
    setFlaggersListOpen(false)
    setHasClickedOnAuthor(false)
    setHasClickedOnFriend(false)
    setHasClickedOnSharers(false)
    setHasClickedOnFlaggers(false)
    try {
      await loadPost(id)
      setLoading(false)
    } catch (err) {
      setError('Some error occurred. Please try again.')
      setLoading(false)
    }
  }

  const handleFlag = () => {
    setFlagging(true)
    if (!thisPost.flaggers.has(curUser.mturkId)) {
      flagPost(id).then(_ => {
        setFlagging(false)
        setPopupMessage('Post flagged successfully.')
        handlePopupOpen()
      }).catch(err => {
        setFlagging(false)
        setPopupMessage('Some error occurred!')
        handlePopupOpen()
      })
    } else {
      unFlagPost(id).then(_ => {
        setFlagging(false)
        setPopupMessage('Flag removed.')
        handlePopupOpen()
      }).catch(err => {
        setFlagging(false)
        setPopupMessage('Some error occurred!')
        handlePopupOpen()
      })
    }
    // var action = thisPost.flaggers.has(currentUserData.mturkId) ? 'unflag' : 'flag'
    // toggleFlagPost(postId, action, friendData)
    //   .then(_ => {
    //     setInitials()
    //     setFlagging(false)
    //     if (action === 'flag') setFlaggedMessage('Post flagged successfully.')
    //     else if (action === 'unflag') setFlaggedMessage('Flag removed.')
    //     handleFlagPopupOpen()
    //   })
    //   .catch(err => {
    //     console.log(err.name, err.message)
    //     setFlagging(false)
    //     setFlaggedMessage('Some error occurred!')
    //     handleFlagPopupOpen()
    //   })
  }

  const handleShare = () => {
    setSharing(true)
    // var friendData = matchedFriend.name ? { ...matchedFriend } : {}
    sharePost(id).then(_ => {
        setSharing(false)
        setPopupMessage('Post shared with your friends successfully.')
        handlePopupOpen()
      }).catch(err => {
        setSharing(false)
        setPopupMessage('Some error occurred!')
        handlePopupOpen()
      })
  }

  const handleContinue = async () => {
    setError('')
    setSubmitting(true)
    try {
      await endPostTime(id)
    } catch (err) {
      setError('Some error occurred. Please try again.')
      setSubmitting(false)
    }
  }

  const handlePopupOpen = () => {
    setPopupOpen(true)
  }

  const handlePopupClose = () => {
    setPopupOpen(false)
  }

  const handleUserProfileCardOpen = (clickedOn, userId, name, gender) => {
    if (clickedOn === 'author') {
      if (!hasClickedOnAuthor) {
        setHasClickedOnAuthor(true)
        clickOnAuthorProfile(id).then(_ => {}).catch(err => {setHasClickedOnAuthor(false)})
      }
    }
    else if (clickedOn === 'friend') {
      if (!hasClickedOnFriend) {
        setHasClickedOnFriend(true)
        clickOnFriendProfile(id).then(_ => {}).catch(err => {setHasClickedOnFriend(false)})
      }
    }
    setUserProfile({ userId, name, gender })
  }

  const handleUserProfileCardClose = () => {
    setUserProfile({})
  }

  const handleSharersListOpen = () => {
    if (!hasClickedOnSharers) {
      setHasClickedOnSharers(true)
      clickOnSharersList(id).then(_ => {}).catch(err => {setHasClickedOnSharers(false)})
    }
    setSharersList(_ => {
      let list = thisPost.initialSharers.map(name => ({ name: name, id: name }))
      if (thisPost.sharers.has(curUser.mturkId))
        list.unshift({ name: `${curUser.name} (you)`, id: curUser.mturkId })
      if (thisPost.friendData.type === 'shared')
        list.unshift({ name: thisPost.friendData.name, id: thisPost.friendData.id })
      return list
    })
    setSharersListOpen(true)
  }

  const handleSharersListClose = () => {
    setSharersListOpen(false)
    setSharersList([])
  }

  const handleFlaggersListOpen = () => {
    if (!hasClickedOnFlaggers) {
      setHasClickedOnFlaggers(true)
      clickOnFlaggersList(id).then(_ => {}).catch(err => {setHasClickedOnFlaggers(false)})
    }
    setFlaggersList(_ => {
      let list = thisPost.initialFlaggers.map(name => ({ name: name, id: name }))
      if (thisPost.flaggers.has(curUser.mturkId))
        list.unshift({ name: `${curUser.name} (you)`, id: curUser.mturkId })
      if (thisPost.friendData.type === 'flagged')
        list.unshift({ name: thisPost.friendData.name, id: thisPost.friendData.id })
      return list
    })
    setFlaggersListOpen(true)
  }

  const handleFlaggersListClose = () => {
    setFlaggersListOpen(false)
    setFlaggersList([])
  }

  const handleExpand = () => {
    if (hasRead) {
      setExpanded(true)
    }
    else {
      if (!reading) {
        setReading(true)
        viewPost(id).then(_ => {
          setReading(false)
          setExpanded(true)
          setHasRead(true)
        }).catch(err => {
          setReading(false)
        })
      }
    }
  }

  const handleCollapse = () => {
    setExpanded(false)
  }

  useEffect(() => {
    handleRefresh()
    //eslint-disable-next-line
  }, [id])

  return (
    <div className='postCard' style={{ marginBottom: '90px' }}>
      <Container maxWidth='md'>
        {loading ?
          <div style={{ textAlign: 'center' }}>
            <CircularProgress color='secondary' />
          </div> :
          error ?
            <ErrorCard message={error} action={handleRefresh} /> :
            thisPost ?
            <>
              <Card elevation={2} className={classes.postCard}>

                <CardActions>
                  <Grid container spacing={1} justifyContent='flex-end'
                    style={{ borderBottom: 'solid 1px #ccc', padding: '2px 4px 0px' }}
                  >
                    {/* {thisPost.friendData.name &&
                        <Grid item xs>
                          <Typography variant='subtitle1'>
                            <strong>
                              <Typography variant='inherit'
                                onClick={_ => {
                                  handleUserProfileCardOpen('friend', thisPost.friendData.id, thisPost.friendData.name)
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                {thisPost.friendData.name}
                              </Typography>
                            </strong>
                            {' ' + thisPost.friendData.type + ' this'}
                          </Typography>
                        </Grid>
                    } */}

                    <Grid item>
                      <OutlinedFlagRounded color='error' className={classes.postCardIcon} style={{ cursor: 'pointer' }} onClick={handleFlaggersListOpen} />
                    </Grid>
                    <Grid item>
                      <Typography variant='body1'>
                        <strong>
                          {(thisPost.friendData.type === 'flagged') &&
                            <>
                              <Typography variant='inherit' style={{ cursor: 'pointer' }}
                              onClick={_ => {
                                handleUserProfileCardOpen('friend', thisPost.friendData.id, thisPost.friendData.name)
                              }}>
                                {thisPost.friendData.name}
                              </Typography>
                              <Typography variant='inherit'>
                                {' and '}
                              </Typography>
                            </>
                          }
                          <Typography variant='inherit' style={{ cursor: 'pointer' }} onClick={handleFlaggersListOpen}>
                            {thisPost.initialFlaggers.length
                            + ((thisPost.friendData.type === 'flagged') ? ' others' : ' people')
                            + ' flagged'
                            }
                          </Typography>
                        </strong>
                      </Typography>
                      {/* <Typography variant='subtitle1' style={{ cursor: 'pointer' }} onClick={handleFlaggersListOpen}>
                        <strong>
                          {
                            (thisPost.initialFlaggers.length + (thisPost.friendData.type === 'flagged') + thisPost.flaggers.has(curUser.mturkId))
                            + ' flag'
                            + ((thisPost.initialFlaggers.length + (thisPost.friendData.type === 'flagged') + thisPost.flaggers.has(curUser.mturkId)) > 1 ? 's' : '')
                          }
                        </strong>
                      </Typography> */}
                    </Grid>

                    <Grid item style={{ marginLeft: 20 }}>
                      <ShareOutlined className={classes.postCardIcon} style={{ color: blue[700], cursor: 'pointer' }} onClick={handleSharersListOpen} />
                    </Grid>
                    <Grid item>
                      <Typography variant='body1'>
                        <strong>
                          {(thisPost.friendData.type === 'shared') &&
                            <>
                              <Typography variant='inherit' style={{ cursor: 'pointer' }}
                              onClick={_ => {
                                handleUserProfileCardOpen('friend', thisPost.friendData.id, thisPost.friendData.name)
                              }}>
                                {thisPost.friendData.name}
                              </Typography>
                              <Typography variant='inherit'>
                                {' and '}
                              </Typography>
                            </>
                          }
                          <Typography variant='inherit' style={{ cursor: 'pointer' }} onClick={handleSharersListOpen}>
                            {thisPost.initialSharers.length
                            + ((thisPost.friendData.type === 'shared') ? ' others' : ' people')
                            + ' shared'
                            }
                          </Typography>
                        </strong>
                      </Typography>
                      {/* <Typography variant='subtitle1' style={{ cursor: 'pointer' }} onClick={handleSharersListOpen}>
                        <strong>
                          {
                            (thisPost.initialSharers.length + (thisPost.friendData.type === 'shared') + thisPost.sharers.has(curUser.mturkId))
                            + ' share'
                            + ((thisPost.initialSharers.length + (thisPost.friendData.type === 'shared') + thisPost.sharers.has(curUser.mturkId)) > 1 ? 's' : '')
                          }
                        </strong>
                      </Typography> */}
                    </Grid>
                  </Grid>
                </CardActions>

                <CardHeader
                  avatar={
                    // <img alt='account-avatar' className={classes.avatar}
                    //   src={`data:image/png;base64,${new Identicon(thisPost.authorData.id, 40).toString()}`}
                    // />
                    <AccountCircle style={{ color: grey[500], fontSize: 40 }} />
                  }
                  title={
                    <Typography variant='subtitle1'>
                      {thisPost.type === 'shared' && 'Shared by '}
                      <Typography variant='inherit' color='primary'
                        onClick={_ => {
                          handleUserProfileCardOpen('author', thisPost.authorData.id, thisPost.authorData.name)
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {thisPost.authorData.name}
                      </Typography>
                    </Typography>
                  }
                  subheader={
                    <Typography variant='caption' color='textSecondary'>
                      {getLocalDateTime(thisPost.createdAt)}
                    </Typography>
                  }
                />

                <CardContent>

                  {/* {thisPost.type === 'shared' &&
                    <Typography variant='body2' color='textSecondary' paragraph>
                      <Link component={RouterLink} to={`/post/${thisPost.orgPostId}`}>
                        View original post
                      </Link>
                      {' by '}
                      <Link component={RouterLink} to={`/user/${refPost.creator}`}>
                        {orgAuthorName}
                      </Link>
                    </Typography>
                  } */}

                  <Typography variant='body1' className={classes.paragraph} paragraph>
                    {expanded ?
                      <>
                        {thisPost.content + ' '}
                        <Typography onClick={handleCollapse}
                          variant='inherit'
                          color='primary'
                          className={classes.readMore}
                        >
                          Collapse
                        </Typography>
                      </> :
                      <>
                        {thisPost.content.substring(0, 130) + ' '}
                        <Typography onClick={handleExpand}
                          variant='inherit'
                          color='primary'
                          className={classes.readMore}
                        >
                          ...Read more
                        </Typography>
                      </>
                    }
                  </Typography>

                  {thisPost.attachments.length ?
                    <ImageList cols={1} rowHeight={250} className={classes.postCardImageList}>
                      {thisPost.attachments.map(a => (
                        <ImageListItem key={a.url} component={Link}
                          href={a.url} target='_blank'
                        >
                          <img src={a.url} alt='' style={{ objectFit: 'contain', height: 250 }} />
                        </ImageListItem>
                      ))}
                    </ImageList> :
                    <></>
                  }

                </CardContent>

                <CardActions>
                  <Grid container spacing={2} alignItems='center' style={{ borderTop: '1px solid #ccc' }}>
                    <Grid item xs>
                      <Button disabled={flagging} onClick={handleFlag} fullWidth style={{ textTransform: 'none' }}>
                        {thisPost.flaggers.has(curUser.mturkId) ?
                          <>
                            <FlagRounded fontSize='large' color='error' className={classes.postCardIcon} />
                            <Typography variant='button'>Un-flag</Typography>
                          </> :
                          <>
                            <OutlinedFlagRounded fontSize='large' color='error' className={classes.postCardIcon} />
                            <Typography variant='button'>Flag</Typography>
                          </>
                        }
                      </Button>
                    </Grid>
                    <Grid item xs>
                      <Button disabled={sharing} onClick={handleShare} fullWidth style={{ textTransform: 'none' }}>
                        {thisPost.sharers.has(curUser.mturkId) ?
                          <Share fontSize='large' style={{ color: blue[700] }} className={classes.postCardIcon} /> :
                          <ShareOutlined fontSize='large' style={{ color: blue[700] }} className={classes.postCardIcon} />
                        }
                        <Typography variant='button'>Share</Typography>
                      </Button>
                    </Grid>
                    <Grid item xs>
                      <Button disabled={submitting} onClick={handleContinue} fullWidth style={{ textTransform: 'none' }}>
                        <Typography variant='button'>Continue</Typography>
                        <NavigateNext fontSize='large' style={{ color: blue[700] }} />
                      </Button>
                    </Grid>
                  </Grid>
                </CardActions>

              </Card>

              {/* <ContinueCard action={handleContinue} disable={loading || flagging || sharing || reading || submitting} /> */}

              <Snackbar
                open={popupOpen}
                message={popupMessage}
                onClose={handlePopupClose}
                autoHideDuration={6000}
              />

              <UserProfileCard open={Boolean(userProfile.name)} userProfile={userProfile} handleClose={handleUserProfileCardClose} />
              <SharersList open={sharersListOpen} list={sharersList} handleClose={handleSharersListClose} />
              <FlaggersList open={flaggersListOpen} list={flaggersList} handleClose={handleFlaggersListClose} />
            </>
            : <></>
        }
    </Container>
    </div>
  )
}

export default PostCard
